import { render, staticRenderFns } from "./ContentBlocksEdit.vue?vue&type=template&id=e22c99d8"
import script from "./ContentBlocksEdit.js?vue&type=script&lang=js&external"
export * from "./ContentBlocksEdit.js?vue&type=script&lang=js&external"
import style0 from "./ContentBlocksEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports